import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { SERVER_API } from '../../fileWithConstants';
import toast from 'react-hot-toast';
import { FaTrash } from "react-icons/fa";
import {Button, Modal, Form,Table,Pagination } from 'react-bootstrap';

const FabricOpeningBalanceRow = ({ onDataChange }) => {
  const [warehouse, setWarehouse] = useState([]);
  const [rows, setRows] = useState([
    { warehouse: '', than_no: '', qty: '', price: '', amount: 0 }
  ]);

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;

    const qty = parseFloat(updatedRows[index].qty) || 0;
    const price = parseFloat(updatedRows[index].price) || 0;
    const net = qty * price;
    updatedRows[index].amount = net.toFixed(2);

    setRows(updatedRows);
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      { warehouse: '', than_no: '', qty: '', price: '', amount: 0 }
    ]);
  };

  const handleDeleteRow = (index) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this row?");
    if (!confirmDelete) return;

    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
  };

  const getWareHouse = async () => {
    try {
      const { data } = await axios.get(`${SERVER_API}/api/v1/supplier/get-warehouse`);
      if (data?.success && data?.wdata.length > 0) {
        setWarehouse(data?.wdata);
      } else {
        toast.error('Something went wrong while getting Warehouse data.');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (onDataChange) onDataChange(rows);
  }, [rows]);

  useEffect(() => {
    getWareHouse();
  }, []);

  return (
    <>
      <table className="table table-responsive table-hover">
        <thead>
          <tr className="align-item">
            <th>#</th>
            <th className="text-center">Warehouse</th>
            <th className="text-center">Thaan No.</th>
            <th className="text-center">Quantity</th>
            <th className="text-center">Unit</th>
            <th className="text-center">Price</th>
            <th className="text-center">Amount INR</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td className="text-center">{index + 1}</td>
              <td className="text-center">
                <select
                  className="form-control"
                  required
                  onChange={(e) => handleRowChange(index, 'warehouse', e.target.value)}
                  value={row.warehouse}
                >
                  <option value="">--Select--</option>
                  {warehouse.map((house) => (
                    <option key={house.id} value={house.id}>{house.name}</option>
                  ))}
                </select>
              </td>
              <td className="text-center">
                <input
                  type="text"
                  className="form-control"
                  value={row.than_no}
                  onChange={(e) => handleRowChange(index, 'than_no', e.target.value)}
                  placeholder="Thaan No."
                  required
                />
              </td>
              <td className="text-center">
                <input
                  type="text"
                  className="form-control"
                  value={row.qty}
                  onChange={(e) => handleRowChange(index, 'qty', e.target.value)}
                  placeholder="QTY"
                  required
                />
              </td>
              <td className="text-center">Mtr</td>
              <td className="text-center">
                <input
                  type="text"
                  className="form-control"
                  value={row.price}
                  onChange={(e) => handleRowChange(index, 'price', e.target.value)}
                  placeholder="Price"
                  required
                />
              </td>
              <td className="text-center">
                <input
                  type="text"
                  className="form-control"
                  value={row.amount}
                  placeholder="Amount"
                  readOnly
                />
              </td>
              <td className="text-center">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDeleteRow(index)}
                  disabled={rows.length === 1}
                >
                  <FaTrash/>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="text-end mt-2">
        <button type="button" className="btn btn-primary btn-sm" onClick={handleAddRow}>
          + Add More Row
        </button>
      </div>
    </>
  );
};

export default FabricOpeningBalanceRow;
